/* eslint-disable no-empty-pattern */
/*
 * @作者: jiguijian(jiguijian@hztianque.com)
 * @描述: drugVisit 请求模块
 * @创建日期: 2020-05-13 09:13:11
 */

import * as apis from './api'

// 初始化store对象
const state = {
  card: '12',
}

// 异步操作放到action handler里
const actions = {
  // 搜索 获取吸毒走访人员档案列表
  async getQueryDatalist({}, payload) {
    const res = await apis.getQueryDatalist(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 获取下la内容
  async getselectList({}, payload) {
    const res = await apis.getselectList(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 新增
  async save({}, payload) {
    const res = await apis.save(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 修改
  async update({}, payload) {
    const res = await apis.update(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 详情
  async details({}, payload) {
    const res = await apis.details(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  // 删除
  async deleteById({}, payload) {
    const res = await apis.deleteById(payload)
    if (res.code && `${res.code}` === '0') {
      return res
    } else {
      throw new Error(res.message)
    }
  },
}
// 根据commit更新store
const mutations = {
  SET_USERINFO(state, info) {
    console.log('ttttt', info)
    state.card = info
  },
}
const getters = {
  getCard(state) {
    return state.card
  },
}
// 导出vuex模块
export default {
  // 模块开启命名空间
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}